import { z } from "zod";

/**
 * Super-admin probe: send one fake incident email through Resend.
 *
 * Independent of the incident channel. Credentials must still be present
 * (`RESEND_API_KEY` + `NOTIFICATION_EMAIL_FROM`). No incident row is written;
 * the point is to prove the provider, the from-address and the template.
 */
export const testIncidentEmailRequestSchema = z.object({
  /**
   * Where to send. Defaults to the caller's own address when omitted.
   * With Resend's shared `onboarding@resend.dev` sender this must be the
   * address that owns the API key (or sit behind `redirectAllEmailTo`).
   */
  to: z.email().optional(),
});

export type TestIncidentEmailRequest = z.infer<typeof testIncidentEmailRequestSchema>;

export const testIncidentEmailResponseSchema = z.object({
  delivered: z.boolean(),
  /** Mailbox that was asked for (after defaulting to the caller). */
  to: z.email(),
  /** Mailbox that actually received it, when a development redirect applied. */
  redirectedTo: z.email().optional(),
  subject: z.string().min(1),
  /** Sanitized provider error when `delivered` is false. */
  error: z.string().min(1).optional(),
});

export type TestIncidentEmailResponse = z.infer<typeof testIncidentEmailResponseSchema>;
